var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6422 0.75C22.95 0.75 25.4956 3.22328 25.4956 7.42232V7.46891H20.2022C17.7389 7.47324 15.7433 9.41893 15.7389 11.8207C15.7356 14.2279 17.7333 16.1823 20.2022 16.1855H25.5V16.5679C25.5 20.767 22.9544 23.25 18.6467 23.25H7.35444C3.04556 23.25 0.5 20.767 0.5 16.5679V7.42232C0.5 3.22328 3.04556 0.75 7.35444 0.75H18.6422ZM13.4789 5.59363H6.42444C5.9 5.5958 5.47444 6.01073 5.47221 6.52315C5.47 7.03774 5.89667 7.45699 6.42444 7.45916H13.4878C14.0156 7.45699 14.4422 7.03774 14.44 6.52206C14.4378 6.00748 14.0067 5.59147 13.4789 5.59363Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.0468 12.3708C18.3082 13.5598 19.3506 14.3963 20.5407 14.3746H24.6031C25.0983 14.3746 25.5 13.9645 25.5 13.4576V10.2931C25.4989 9.78728 25.0983 9.37609 24.6031 9.375H20.4451C19.0913 9.37935 17.9979 10.5031 18 11.8878C18 12.0499 18.0159 12.212 18.0468 12.3708Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13.125C21.1904 13.125 21.75 12.5654 21.75 11.875C21.75 11.1846 21.1904 10.625 20.5 10.625C19.8096 10.625 19.25 11.1846 19.25 11.875C19.25 12.5654 19.8096 13.125 20.5 13.125Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.dae3f693eb20e8542a0d05c2ac54cd66.svg";
export { ForwardRef as ReactComponent };